import React from 'react';
import PropTypes from 'prop-types';
import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

const { classNames } = Mobi2Go.helpers;

class Percentage extends React.Component {
    static propTypes = {
        selected: PropTypes.bool.isRequired,
        onSelect: PropTypes.func.isRequired,
        value: PropTypes.number.isRequired,
        exceeds: PropTypes.bool.isRequired,
        t: PropTypes.func.isRequired,
    };

    onKeyPressHandler = e => {
        if (e.key !== 'Enter') {
            return;
        }

        this.onClickHandler();
    };

    onClickHandler = () => {
        const { onSelect, value } = this.props;
        onSelect(value);
    };

    render() {
        const { selected, value, exceeds, t } = this.props;
        return (
            <div
                role="button"
                className={classNames('m2g-order-tip-modal-percentage', {
                    'm2g-order-tip-modal-percentage--selected': selected,
                })}
                tabIndex="0"
                key={value}
                onKeyPress={this.onKeyUpHandler}
                onClick={this.onClickHandler}
            >
                {t('percentage', { value })}
                {exceeds ? '+' : ''}
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.tip-modal')(Percentage);
